"use strict";

exports.__esModule = true;
exports.DurationInput = void 0;
var _core = require("@blueprintjs/core");
var _TranslatorContext = require("../../Core/Translator/TranslatorContext");
var _react = _interopRequireWildcard(require("react"));
var _CommonValidators = require("../utils/CommonValidators");
var _styles = require("../styles");
var _styles2 = require("./styles");
var _vimanaTypes = require("@vimana/vimana-types");
var _Core = require("../../Core");
var _utils = require("./utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var DurationInput = exports.DurationInput = function DurationInput(_ref) {
  var value = _ref.value,
    setDuration = _ref.setDuration,
    showOptions = _ref.showOptions;
  var _useContext = (0, _react.useContext)(_TranslatorContext.TranslatorContext),
    translate = _useContext.translate;
  var unitTypes = (0, _utils.getUnitTypes)(translate);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles2.Row, null, /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
    "data-testid": "EnrichEditorUI.DurationInput.Duration",
    checked: value ? true : false,
    onChange: function onChange(e) {
      return e.currentTarget.checked ? setDuration({
        value: "",
        withAllowance: false
      }) : setDuration(undefined);
    }
  }, translate("EnrichEditorUI.DurationInput.Duration", "Duration")), value && /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
    "data-testid": "EnrichEditorUI.DurationInput.WithAllowance",
    checked: value ? value.withAllowance : false,
    onChange: function onChange(e) {
      return value ? setDuration(Object.assign({}, value, {
        withAllowance: e.currentTarget.checked
      })) : null;
    }
  }, translate("EnrichEditorUI.DurationInput.WithAllowance", "With allowance"))), value && /*#__PURE__*/_react["default"].createElement(_styles.FlexRow, null, /*#__PURE__*/_react["default"].createElement("span", null, translate("EnrichEditorUI.DurationInput.DurationFor", "For")), /*#__PURE__*/_react["default"].createElement(_styles.Spacer, null), /*#__PURE__*/_react["default"].createElement(_core.NumericInput, _extends({
    "data-testid": "EnrichEditorUI.DurationInput.DurationInput",
    value: value == null ? void 0 : value.value,
    min: 0,
    allowNumericCharactersOnly: true,
    style: {
      width: "75px"
    },
    onValueChange: function onValueChange(event) {
      return setDuration(Object.assign({}, value, {
        value: event
      }));
    }
  }, !(0, _CommonValidators.validateEmptyField)(value == null ? void 0 : value.value) && {
    intent: _core.Intent.DANGER
  })), /*#__PURE__*/_react["default"].createElement(_styles.Spacer, null), /*#__PURE__*/_react["default"].createElement(_Core.Selector, _extends({
    dataTestId: "EnrichEditorUI.DurationInput.UnitType",
    placeholder: translate("EnrichEditorUI.DurationInput.UnitType", "Select unit type"),
    getKey: function getKey(item) {
      return item.value;
    },
    renderItemText: function renderItemText(item) {
      return item.displayName;
    },
    items: unitTypes,
    selected: (value == null ? void 0 : value.unitType) && [unitTypes.find(function (unitType) {
      return unitType.value === (value == null ? void 0 : value.unitType);
    })],
    onSelect: function onSelect(_ref2) {
      var event = _ref2[0];
      return setDuration(Object.assign({}, value, {
        unitType: event.value
      }));
    }
  }, !(0, _CommonValidators.validateEmptyField)(value == null ? void 0 : value.unitType) && {
    style: Object.assign({}, true && {
      border: "solid 1px red"
    })
  })), showOptions && /*#__PURE__*/_react["default"].createElement(_styles2.StyledRadioGroup, null, /*#__PURE__*/_react["default"].createElement(_core.Radio, {
    "data-testid": "EnrichEditorUI.DurationInput.None",
    style: {
      marginRight: "10px"
    },
    label: translate("EnrichEditorUI.None", "None"),
    value: "none",
    checked: (value == null ? void 0 : value.from) == null || (value == null ? void 0 : value.from) === "none",
    onChange: function onChange() {
      setDuration(Object.assign({}, value, {
        from: null
      }));
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Radio, {
    "data-testid": "EnrichEditorUI.DurationInput.FromStart",
    style: {
      marginLeft: "10px"
    },
    label: translate("EnrichEditorUI.DurationInput.FromStart", "From Start"),
    value: "from-start",
    checked: (value == null ? void 0 : value.from) === "from-start",
    onChange: function onChange() {
      setDuration(Object.assign({}, value, {
        from: "from-start"
      }));
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Radio, {
    "data-testid": "EnrichEditorUI.DurationInput.FromNow",
    style: {
      marginLeft: "10px"
    },
    label: translate("EnrichEditorUI.DurationInput.FromNow", "From Now"),
    value: "from-now",
    checked: (value == null ? void 0 : value.from) === "from-now",
    onChange: function onChange() {
      setDuration(Object.assign({}, value, {
        from: "from-now"
      }));
    }
  }))));
};